module.exports = {
      id: "proofread-usage",
      viewBox: "0 0 21.271 15.261",
      url: "/" + "sprite-5d017f3fe034ec5d98a70bae909b913a.svg#proofread",
      toString: function () {
        return this.url;
      }
    }